/* #*/ export const PERSON = `
name:
  first: Corey
  middle:
  last: Coburn
about:
position: I am a full-stack web developer with 8 years professional experience. My passion for this constantly evolving field resonates deeply with me. I am consistently pushing myself to grow and become a better developer and being a part of a team with similar goals.

birth:
  location: San Francisco Bay Area

experience:
- company: Certified Parking Attendants, LLC
  position: Full-Stack Web Developer
  timeperiod: 2011 - 2019 (current)
  description: Sole developer of a private greenfield web application that runs the critical day-to-day operations of the business. Built with modern APIs, LEAP is a custom CRM and ERM. The app provides features such as the generation of business proposals and contracts, payment processing, extensive staff/event scheduling, streamline hiring, generating business reports, among other essential business processes.

- company: Certified Parking Attendants, LLC
  position: Operations Manager
  timeperiod: 2008 - 2019 (current)
  description: Overseeing the services that Certified Parking Attendants offer to ensure that clients and employees feel valued. Leading a large team at events in the Bay Area at high profile locations to ensure superior customer service. Building great employee / customer rapport.

- company: Target Corporation
  position: Executive Team Leader
  timeperiod: 2005 - 2008
  description: Drive sales by overseeing the customer service and merchandising of six to eight departments with sales ranging from $2 - $9 million. Set goals and expectations for the store. Strive to achieve sales goals and maintain budget controls. Coach and follow up with employees, including performing reviews and corrective action.

education:
- degree: Bachelor of Science, Major in Business Administration, Sonoma State University
  timeperiod: August 2001 - May 2005
  description: Focus in Small Business Management.

# skill level goes 0 to 100
skills:
- name: PHP
  level: 90
- name: Laravel
  level: 75
- name: Vue
  level: 80
- name: ES6
  level: 70
- name: MySQL
  level: 80
knowledge: "Currently using the following tech stack in my greenfield projects: Laravel for API develoment, Vue / Nuxt for SSR / SPA, Tailwind CSS, SASS, Webpack, MySQL. Learning React and GraphQL."

contact:
  email: corey@coburn.codes
  phone: (707) 806-2644
  city: Santa Rosa, CA
  website: https://coburn.codes
  github: coreycoburn

lang: en
`



//////////////////
// WEBPACK FOOTER
// ./resume/data.yml
// module id = 99
// module chunks = 1